var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-container',{staticClass:"fill-height",attrs:{"fluid":""}},[_c('v-row',{attrs:{"align":"center","justify":"center"}},[_c('span',[_vm._v(_vm._s(_vm.$t("PasswordForgotten_SetPasswordExpired")))])])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }